import config from './params.config';
import cookie from '../assets/js/cookie/cookie';

// 配置API接口地址
var baseUrl = '';
var appKey = '';
var datacenterUrl = '';
var datacenterKey = '';
var scrmUrl = config.SCRM_PATH_HOST;

if (location.hostname === 'localhost' || location.hostname === '192.168.1.93') {
  // baseUrl = config.API_PATH_LOCAL;
  baseUrl = config.API_PATH_DEV;
  appKey = config.APPKEY_DEV;
  datacenterKey = config.DATA_CENTER_APPKEY_DEV;
  datacenterUrl = config.DATA_CENTER_API_PATH_DEV;
}
if (location.hostname === config.LOCALHOST_DEV || location.hostname === config.LOCALHOST_FAT || location.hostname === config.LOCALHOST_FAT_OLD ) {
  baseUrl = config.API_PATH_DEV;
  appKey = config.APPKEY_DEV;
  datacenterKey = config.DATA_CENTER_APPKEY_DEV;
  datacenterUrl = config.DATA_CENTER_API_PATH_DEV;
}
// if (location.hostname === 'ehr-wechat-vue.efckudu.lunz.cn') {
//   baseUrl = config.API_PATH_LIVE;
//   appKey = config.APPKEY_LIVE;
// }
if (location.hostname === config.LOCALHOST_PROD || location.hostname === config.LOCALHOST_PROD_OLD) {
  baseUrl = config.API_PATH_PROD;
  appKey = config.APPKEY_PROD;
  datacenterKey = config.DATA_CENTER_APPKEY_PROD;
  datacenterUrl = config.DATA_CENTER_API_PATH_PROD;
}
// 引用axios
var axios = require('axios');

// 基础
function handleAxios(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  axios({
    method: method,
    url: url + '?appKey=' + escape(appKey),
    // url: url + '?appKey=' + escape(appKey),
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    withCredentials: false,
    baseURL: baseUrl
  }).then(function (res) {
    if (success) {
      success(res.data)
    }
    else {
      failure(res.data)
    }
  })
    .catch(function (err) {
      console.log('+++' + err)
    })
}

function handleAxiosWithToken(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  axios({
    method: method,
    url: url + '?appKey=' + escape(appKey) + (cookie.get('AUTHTOKEN') ? '&authToken=' +  cookie.get('AUTHTOKEN') : ''),
    // url: url + '?appKey=' + escape(appKey),
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    withCredentials: false,
    baseURL: baseUrl
  }).then(function (res) {
    if (success) {
      success(res.data)
    }
    else {
      failure(res.data)
    }
  })
    .catch(function (err) {
      console.log('+++' + err)
    })
}

// 文件上传
function UploadFileAxios(method, url, data, success, failure) {
  axios({
    method: method,
    url: url + '?appKey=' + escape(appKey),
    data: data,
    withCredentials: false,
    baseURL: baseUrl,
    headers:{'Content-Type': 'multipart/form-data'}
  }).then(function (res) {
    if (success) {
      success(res.data)
    }
    else {
      failure(res.data)
    }
  })
    .catch(function (err) {
      console.log('+++' + err)
    })
}

// 数据中心
function dataCenterAxios(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  axios({
    method: method,
    url: url + '?appKey=' + escape(datacenterKey),
    data: params,
    params: method === 'GET' || method === 'DELETE' ? params : null.params,
    withCredentials: false,
    baseURL: datacenterUrl
  })
    .then(function (res) {
      success(res)
    })
    .catch(function (err) {
      console.log('+++' + err)
    })
}

function scrmAxios(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  axios({
    method: method,
    url: url,
    data: params,
    params: method === 'GET' || method === 'DELETE' ? params : null.params,
    withCredentials: false,
    baseURL: datacenterUrl
  })
    .then(function (res) {
      success(res)
    })
    .catch(function (err) {
      console.log('+++' + err)
    })
}

// scrm系统
function scrmApiAxios(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  axios({
    method: method,
    headers:{
      appKey: escape(config.SCRM_PATH_KEY)
    },
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    withCredentials: false,
    baseURL: scrmUrl
  })
    .then(function (res) {
      success(res)
    })
    .catch(function (err) {
      console.log('+++' + err)
    })
}

// 异步等待
async function http (method, url, params) {
  if (params) {
    params = filterNull(params)
  }
  try {
    let res = await await axios({
      method: method,
      url: url + '?appKey=' + escape(appKey) + (cookie.get('AUTHTOKEN') ? '&authToken=' +  cookie.get('AUTHTOKEN') : ''),
      // url: url + '?appKey=' + escape(appKey),
      data: method === 'POST' || method === 'PUT' ? params : null,
      params: method === 'GET' || method === 'DELETE' ? params : null,
      withCredentials: false,
      baseURL: baseUrl
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
    // res = res.data;
    return new Promise((resolve) => {
      if (res == 'Error: Network Error') {
        resolve({
          'AllMessages': '网络连接失败！',
          'Data': null,
          'HasErrors': true,
          'Messages': ['网络连接失败！'],
          'Success': false,
        });
      } else {
        res = res.data;
        // if (res.Success) {
        //   resolve(res.Data);
        // } else {
          resolve(res);
        // }
      }
    })
  } catch (err) {
    console.log(err);
  }
}

// 参数过滤
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
  }
  if (toType(o[key]) === 'string') {
    o[key] = o[key].trim()
  } else if (toType(o[key]) === 'object') {
    o[key] = filterNull(o[key])
  } else if (toType(o[key]) === 'array') {
    o[key] = filterNull(o[key])
  }
  return o
}

// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}

// 导出
export default {
  handleGetToken(url, params, success, failure) {
    return handleAxios('GET', url, params, success, failure);
  },
  handlePostToken(url, params, success, failure) {
    return handleAxios('POST', url, params, success, failure);
  },
  handleGet(url, params, success, failure) {
    return handleAxiosWithToken('GET', url, params, success, failure);
  },
  handlePost(url, params, success, failure) {
    return handleAxiosWithToken('POST', url, params, success, failure);
  },
  DataCenterGet(url, params, success, failure) {
    return dataCenterAxios('GET', url, params, success, failure);
  },
  handleGetSCRM(url, params, success, failure) {
    return scrmApiAxios('GET', url, params, success, failure);
  },
  async httpGet(url, params) {
    return http('GET', url, params);
  },
  async httpPost(url, params) {
    return http('POST', url, params);
  },
}
